import React from 'react';
import {solid} from "@fortawesome/fontawesome-svg-core/import.macro";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useDispatch} from "react-redux";
import {openModal} from "@/Store/Slices/ModalSlice";

const MultiplePublishMerchants = ({checked}) => {
  const dispatch = useDispatch();

  const handleMultipleAction = () => {
    dispatch(openModal({
      modalType: 'multiple-coupon-modal',
      modalProps: {
        ids: checked,
        url: 'added.merchants.multi.publish',
        text: 'Do you want to publish selected merchants?',
      }
    }));
  }

  return (
      <button onClick={handleMultipleAction} className={'mr-3'} data-tip="Multiple publish merchants" >
        <FontAwesomeIcon
          color={'green'}
          size={'lg'}
          icon={solid('arrow-right-long')}/>
      </button>
  );
};

export default MultiplePublishMerchants;
